import classNames from "classnames";

import styles from "./LoadingIndicator.module.css";

export default function LoadingIndicator({className}: {className?: string}) {
  return <span className={classNames(className, styles.loader)} />;
}
